import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import api from "api/axiosConfig";
import API_BASE from "configs/hostConfig";

import CenteredWrapper from "ui/CenteredWrapper";
import Heading from "ui/Heading";
import { FlexItem, HR } from "components/forms/Forms.styles";
import RelayPromptForm from "./ReplayPromptForm";
import AccessDenied from "components/AccessDenied";

const CreateRelayPromptPage = () => {
  const navigate = useNavigate();
  const isAuthenticated = useSelector((state) => state.user.isAuthenticated);
  const isAdmin = useSelector((state) => state.user.isAdmin);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const initPrompt = {
    promptTitle: "",
    illustration: "",
    thumbnailUrl: "",
    starter: "",
    instruction: "",
    genre: "",
    segmentLength: null,
    maxWordCount: null,
    maxRound: null,
    minSegmentWordCount: null,
    maxSegmentWordCount: null,
    sprintInMinutes: null,
    style: "",
    tags: [""],
  };

  const createPrompt = async (values, status) => {
    console.log("create relay promt, values: ", values, "status: ", status);
    api
      .post(`${API_BASE}/api/relay-prompt/create`, { ...values, status })
      .then((res) => {
        if (res.status == 200) {
          const promptId = res.data;
          navigate(`/relay-prompt/${promptId}`);
        }
      })
      .catch(() => alert("Failed to create a new essay prompt."))
      .finally(() => setIsSubmitting(false));
  };

  if (!isAuthenticated || !isAdmin) {
    return <AccessDenied />;
  }

  return (
    <CenteredWrapper
      display="flex"
      justifyContent="start"
      flexDirection="column"
      mt="80px"
      minHeight="calc(100vh - 180px)"
      maxWidth="900px"
    >
      <FlexItem>
        <Heading variant="h2">New Story Relay Prompt</Heading>
      </FlexItem>
      <HR className="light" />
      <RelayPromptForm
        data={initPrompt}
        updatePrompt={createPrompt}
        isDisabled={isSubmitting}
      />
    </CenteredWrapper>
  );
};

export default CreateRelayPromptPage;
